import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  personalcommitments: { nuevos: [], pendientes: [] },
  personalcommitment: {}
}

const mutations = {  
  SET_PERSONALCOMMITMENTS (state, payload) {
    state.personalcommitments = payload
  },
  SET_PERSONALCOMMITMENT (state, payload) {
    state.personalcommitment = payload
  },
  ADD_PERSONALCOMMITMENTS (state, payload) {
    state.personalcommitments.nuevos.push(payload)
  },
  DELETE_PERSONALCOMMITMENTS (state, payload) {
    state.personalcommitments.nuevos = state.personalcommitments.nuevos.filter(element => {
      return element._id != payload
    })
  },
  CLOSE_PERSONALCOMMITMENTS (state, payload) {
    state.personalcommitments.pendientes = state.personalcommitments.pendientes.filter(element => {
      return element._id != payload
    })
  },
  CONTINUE_PERSONALCOMMITMENTS (state, payload) {
    state.personalcommitments.nuevos.push(payload)
    state.personalcommitments.pendientes = state.personalcommitments.pendientes.filter(element => {
      return element._id != payload._id
    })
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  personalCommitmentList: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-commitment`)    
      .then((response) => {        
        context.commit('SET_PERSONALCOMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getPcByIdPlan: (context, data) => {
    const { id, user } = data
    return Vue.http.get(`${env.API}/api/personal-commitment/by-plan/${id}/${user}`)    
      .then((response) => {        
        context.commit('SET_PERSONALCOMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createPC: (context, data) => {
    return Vue.http.post(`${env.API}/api/personal-commitment`, data)    
      .then((response) => {        
        context.commit('ADD_PERSONALCOMMITMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        console.log(error)
        return context.commit('API_FAILURE', error)
      })
  },
  getPCById: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-commitment/${id}`)    
      .then((response) => {        
        context.commit('SET_PERSONALCOMMITMENT', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },  
  addCommentToPersonalCommitment: (context, data) => {
    return Vue.http.post(`${env.API}/api/personal-commitment/comment`, data)    
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommentsFromPersonalCommitment: (context, id) => {
    return Vue.http.get(`${env.API}/api/personal-commitment/comments/${id}`)
    .then(response => {
        return response.body.message
    })
    .catch(error => {
        return context.commit('API_FAILURE', error)
    })
  },
  close: (context, id) => {
    return Vue.http.delete(`${env.API}/api/personal-commitment/${id}`)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  deletePersonalCommitment: (context, id) => {
    return Vue.http.delete(`${env.API}/api/personal-commitment/remove/${id}`)    
      .then((response) => {      
        context.commit('DELETE_PERSONALCOMMITMENTS', response.body.commitment)       
        return response.body.success
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closePersonalCommitment: (context, data) => {
    const { id, accomplished } = data
    return Vue.http.put(`${env.API}/api/personal-commitment/${id}`, { accomplished })
    .then(response => {
      context.commit('CLOSE_PERSONALCOMMITMENTS', response.body.message)       
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  continuePersonalCommitment: (context, data) => {
    const { pc, plan } = data
    return Vue.http.put(`${env.API}/api/personal-commitment/${pc._id}`, { plan })
    .then(response => {
      context.commit('CONTINUE_PERSONALCOMMITMENTS', pc)       
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  }
}

const getters = {
  getpersonalCommitments: (state) => state.personalcommitments,
  getpersonalCommitment: (state) => state.personalcommitment
}

export const personalcommitments = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/personalcommitments.js